module.exports = __webpack_public_path__ + "img/phone.d47f0f8e.png";